import {
  isDateObject,
  isNonEmpty,
  isNumber,
  isNumberOrNull,
  isString,
  isValidDate,
} from '@toolbox/utils';
import { createValidator, extendErrorMessage, passEmpty } from './core';
import { EMAIL_REGEX } from './regexes';
import { validatePhone } from '@widget/api/queries';

import type { PhoneValidationError } from './types';

export * as regexes from './regexes';

export function validPhoneByRegexp(value: string) {
  return /^\+\d{1,3} ?[1-9] ?(\d ?){3,}$/.test(value);
}

export const date = createValidator<unknown>(
  passEmpty(
    ({ value }) =>
      (isNumber(value) || isString(value) || isDateObject(value)) && isValidDate(new Date(value)),
  ),
)(() => 'invalidDate')();

export const phoneNumber = ({ message, useApi }: { message: string; useApi: boolean }) =>
  createValidator<unknown, undefined, PhoneValidationError | boolean>(
    passEmpty(async ({ value }) => {
      if (!isString(value) || !validPhoneByRegexp(value)) {
        return false;
      }

      if (useApi) {
        const validationResult = await validatePhone(value, 1000);
        // pass validation if api call fails
        return validationResult?.isValid ?? true;
      }

      return true;
    }),
  )(() => message)();

export const regex = createValidator<unknown, RegExp>(
  passEmpty(({ value }, regex) => {
    return isString(value) && regex.test(value);
  }),
)(() => 'noMatch');

export const email = extendErrorMessage(regex(EMAIL_REGEX), () => 'invalidEmail');

export const min = createValidator(
  passEmpty(({ value }, config) => {
    return isNumberOrNull(value) && isNumber(config) && value >= config;
  }),
)(() => 'valueTooLow');

export const required = createValidator(({ value }) => {
  return isNonEmpty(value);
})(() => 'requiredField');
